module.exports = __webpack_public_path__ + "img/23.3180f5e5.jpg";